import {
  DRAWER_ACTIONS,
  LEVEL_TITLES,
} from '../../../common/constants/CommonConstants';

export const PIPELINE_TYPES = {
  OPPORTUNITY: 'Opportunity',
  RISK: 'Risk',
};

export const WEBHOOK_ENTITY_LEVEL_ID_MAP = {
  [LEVEL_TITLES.organization]: 1,
  [LEVEL_TITLES.account]: 2,
  [LEVEL_TITLES.contact]: 3,
  [PIPELINE_TYPES.OPPORTUNITY]: 4,
  [PIPELINE_TYPES.RISK]: 4,
};

export const WEBHOOK_EVENT_TYPES = {
  CREATED: 'Created',
  UPDATED: 'Updated',
  ARCHIVED: 'Archived',
  CHURNED: 'Churned',
};

export const WEBHOOK_ENTITY_EVENT_TYPES = {
  [LEVEL_TITLES.organization]: [
    WEBHOOK_EVENT_TYPES.CREATED,
    WEBHOOK_EVENT_TYPES.UPDATED,
    WEBHOOK_EVENT_TYPES.ARCHIVED,
    WEBHOOK_EVENT_TYPES.CHURNED,
  ],
  [LEVEL_TITLES.account]: [
    WEBHOOK_EVENT_TYPES.CREATED,
    WEBHOOK_EVENT_TYPES.UPDATED,
    WEBHOOK_EVENT_TYPES.ARCHIVED,
    WEBHOOK_EVENT_TYPES.CHURNED,
  ],
  [LEVEL_TITLES.contact]: [
    WEBHOOK_EVENT_TYPES.CREATED,
    WEBHOOK_EVENT_TYPES.UPDATED,
    WEBHOOK_EVENT_TYPES.ARCHIVED,
  ],
  [PIPELINE_TYPES.OPPORTUNITY]: [
    WEBHOOK_EVENT_TYPES.CREATED,
    WEBHOOK_EVENT_TYPES.UPDATED,
    WEBHOOK_EVENT_TYPES.ARCHIVED,
  ],
  [PIPELINE_TYPES.RISK]: [
    WEBHOOK_EVENT_TYPES.CREATED,
    WEBHOOK_EVENT_TYPES.UPDATED,
    WEBHOOK_EVENT_TYPES.ARCHIVED,
  ],
};

export const WEBHOOK_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const WEBHOOK_STATUS_MAP = {
  0: WEBHOOK_STATUS.INACTIVE,
  1: WEBHOOK_STATUS.ACTIVE,
};
export const REQUEST_METHODS = {
  POST: 'POST',
  // others are out of scope for v1
  // GET: 'GET',
  // PUT: 'PUT',
  // DELETE: 'DELETE'
};

export const REQUEST_FORMATS = {
  JSON: 'JSON',
  // others are out of scope for v1
  // XML: 'XML'
};
export const WEBHOOK_AUTH_TYPES = {
  NONE: {
    value: 'NONE',
    displayName: 'None',
  },
  BASIC: {
    value: 'BASIC',
    displayName: 'Basic',
  },
  TOKEN: {
    value: 'TOKEN',
    displayName: 'Token',
  },
};

const SYSTEM_FIELDS = {
  PULSE: {
    displayName: 'CSM Pulse',
    name: 'pulse',
  },
  LIFECYCLE: {
    displayName: 'Lifecycle Stage',
    name: 'lifecycle',
  },
  OWNER: {
    displayName: 'Owners',
    name: 'owner',
  },
  EMAIL: {
    displayName: 'Email',
    name: 'email',
  },
  PIPELINE_STATUS: {
    displayName: 'Pipeline Status',
    name: 'pipelineStatus',
  },
};

export const WEBHOOK_APPLICABLE_SYSTEM_FIELDS = {
  1: {
    [SYSTEM_FIELDS.PULSE.name]: SYSTEM_FIELDS.PULSE,
    [SYSTEM_FIELDS.LIFECYCLE.name]: SYSTEM_FIELDS.LIFECYCLE,
    [SYSTEM_FIELDS.OWNER.name]: SYSTEM_FIELDS.OWNER,
  },
  2: {
    [SYSTEM_FIELDS.PULSE.name]: SYSTEM_FIELDS.PULSE,
    [SYSTEM_FIELDS.LIFECYCLE.name]: SYSTEM_FIELDS.LIFECYCLE,
    [SYSTEM_FIELDS.OWNER.name]: SYSTEM_FIELDS.OWNER,
  },
  3: {
    [SYSTEM_FIELDS.PULSE.name]: SYSTEM_FIELDS.PULSE,
    [SYSTEM_FIELDS.EMAIL.name]: SYSTEM_FIELDS.EMAIL,
    [SYSTEM_FIELDS.LIFECYCLE.name]: SYSTEM_FIELDS.LIFECYCLE,
  },
  4: {
    [SYSTEM_FIELDS.LIFECYCLE.name]: SYSTEM_FIELDS.LIFECYCLE,
  },
};

export const RESPONSE_STATUS_TEXT = {
  SUCCESS: 'SUCCESS',
  TIMEOUT: 'TIMEOUT',
  CLIENT_ERROR: 'CLIENT_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  UNKNOWN: 'UNKNOWN',
};
export const RESPONSE_STATUS_DISPLAY_NAME = {
  [RESPONSE_STATUS_TEXT.SUCCESS]: 'Success',
  [RESPONSE_STATUS_TEXT.TIMEOUT]: 'Timeout',
  [RESPONSE_STATUS_TEXT.CLIENT_ERROR]: 'Client Error',
  [RESPONSE_STATUS_TEXT.SERVER_ERROR]: 'Server Error',
  [RESPONSE_STATUS_TEXT.UNKNOWN]: 'Unknown',
};

export const RESPONSE_TAG_COLOR_MAP = {
  [RESPONSE_STATUS_TEXT.UNKNOWN]: 'grey',
  [RESPONSE_STATUS_TEXT.TIMEOUT]: 'red',
  [RESPONSE_STATUS_TEXT.CLIENT_ERROR]: 'red',
  [RESPONSE_STATUS_TEXT.SERVER_ERROR]: 'red',
  [RESPONSE_STATUS_TEXT.SUCCESS]: 'green',
};

export const STATUS_TAG_COLOR_MAP = {
  0: 'orange',
  1: 'green',
};

export const DRAWER_TITLES = {
  [DRAWER_ACTIONS.VIEW]: 'Webhook Details',
  [DRAWER_ACTIONS.ADD]: 'Add Webhook',
  [DRAWER_ACTIONS.EDIT]: 'Edit Webhook',
  [DRAWER_ACTIONS.DUPLICATE]: 'Duplicate Webhook',
};
